// vue
import mixin from './mixin.js';
if(document.querySelector('#app.js-basic')) {
	Vue.createApp({
		mixins: [mixin],
		mounted() {}
	}).mount('#app.js-basic');
}